import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypeArchiveFailedAction = {
	type: 'SUBJECT_TYPE_ARCHIVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypeArchiveFailedAction => ({
	type: 'SUBJECT_TYPE_ARCHIVE_FAILED',
	payload,
});
